module.exports = __webpack_public_path__ + "img/pie.f803514a.svg";